'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _metaballs = require('../metaballs');

var _highlights = require('../highlights');

var _shapes = require('./shapes');

var _shapes2 = _interopRequireDefault(_shapes);

var _delimiters = require('./delimiters');

var _drops = require('./drops');

var _drops2 = _interopRequireDefault(_drops);

var _labels = require('./labels');

var _labels2 = _interopRequireDefault(_labels);

var _lineSeparator = require('./lineSeparator');

var _lineSeparator2 = _interopRequireDefault(_lineSeparator);

var _xAxis = require('./xAxis');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (svg, dimensions, scales, configuration) {
    var defs = svg.append('defs');
    var labelsWidth = configuration.leftWidth;
    var width = dimensions.width - labelsWidth;
    defs.append('clipPath').attr('id', 'drops-container-clipper').append('rect').attr('id', 'drops-container-rect').attr('width', width).attr('height', dimensions.height + configuration.margin.top + configuration.margin.bottom);

    var labelsContainer = svg.append('g').classed('labels', true).attr('width', configuration.labelsWidth).attr('transform', 'translate(0, ' + configuration.lineHeight + ')');

    var chartWrapper = svg.append('g').attr('class', 'chart-wrapper').attr('width', dimensions.width - width).attr('transform', 'translate(' + labelsWidth + ', ' + configuration.margin.top + ')');

    var dropsContainer = chartWrapper.append('g').classed('drops-container', true).attr('clip-path', 'url(#drops-container-clipper)');

    var shapesContainer = chartWrapper.append('g').classed('shapes-container', true).attr('clip-path', 'url(#drops-container-clipper)');

    if (configuration.metaballs) {
        dropsContainer.style('filter', 'url(#metaballs)');
    }
    if (configuration.highlights) {
        (0, _highlights.highlights)(defs);
    }

    chartWrapper.append('g').classed('extremum', true).attr('width', dimensions.width).attr('height', 30).attr('transform', 'translate(0, -35)');

    if (configuration.metaballs) {
        (0, _metaballs.metaballs)(defs);
    }

    var axesContainer = chartWrapper.append('g').classed('axes', true);
    var lineSeparator = (0, _lineSeparator2.default)(scales, configuration, dimensions);

    var labels = (0, _labels2.default)(labelsContainer, scales, configuration);

    var drops = (0, _drops2.default)(dropsContainer, scales, configuration);

    var shapes = (0, _shapes2.default)(shapesContainer, scales, configuration);

    return function (data) {
        lineSeparator(axesContainer, data);
        (0, _delimiters.delimiters)(svg, scales, labelsWidth, configuration.dateFormat);
        drops(data);
        shapes(data);
        labels(data);
        if ((0, _xAxis.boolOrReturnValue)(configuration.hasTopAxis, data)) {
            (0, _xAxis.drawTopAxis)(axesContainer, scales.x, configuration, dimensions);
        }
        if ((0, _xAxis.boolOrReturnValue)(configuration.hasBottomAxis, data)) {
            (0, _xAxis.drawBottomAxis)(axesContainer, scales.x, configuration, dimensions);
        }
    };
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/ansyn-event-drops/dist-es5/drawer/index.js
// module id = ../../../../ansyn-event-drops/dist-es5/drawer/index.js
// module chunks = vendor